module.exports = __webpack_public_path__ + "static/media/sv4.33ccec22.jpg";